module.exports = __webpack_public_path__ + "img/icon-user-gray.358f6c01.svg";